import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { getDeviceId } from "../../lib/storage";
import { PopButton } from "../PopButton";
import { Panel } from "../PageShell";
import type { GroupState } from "./GroupParts";

export function JoinCard({ group, onJoined }: { group: GroupState; onJoined: () => void }) {
  const [name, setName] = useState("");
  const [suggestion, setSuggestion] = useState("");
  const [busy, setBusy] = useState(false);

  const join = async (n: string) => {
    if (!n.trim()) return;
    setBusy(true);
    try {
      await api.post(`/groups/${group.id}/join`, { name: n, device_id: getDeviceId() });
      onJoined();
    } catch (e: any) {
      const msg = apiError(e);
      const m = msg.match(/"([^"]+)"/);
      setSuggestion(e.response?.status === 409 && m ? m[1] : "");
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Panel>
      <p className="font-display text-2xl font-bold uppercase">{group.host_name} wants your vote</p>
      <p className="mb-4 text-sm font-semibold text-zinc-600">Enter a name so everyone knows who voted.</p>
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); join(name); }}>
        <input className="field" maxLength={30} placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} data-testid="group-join-name-input" />
        <PopButton type="submit" tone="purple" disabled={busy || !name.trim()} data-testid="group-join-button">Join</PopButton>
      </form>
      {suggestion && (
        <button className="chip mt-3 bg-pop-yellow" onClick={() => { setName(suggestion); join(suggestion); }} data-testid="group-join-suggestion-button">Use “{suggestion}”</button>
      )}
    </Panel>
  );
}
